import Vue from 'vue'
import VSwatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'
Vue.use(VSwatches);
